import React from 'react'
import { Navbar, NavbarBrand, Nav, Collapse, NavItem } from 'reactstrap'
import logo from '../Logo.png'

const NavigationLoading = () => {
  return (
    <Navbar color="primary" dark expand="md" className="fixed-top" style={{ transition: '0.5s ease' }}>
      <NavbarBrand>
        <img style={{ marginRight: '1rem' }} height={30} src={logo} alt="OSIT" />
        User Manager
      </NavbarBrand>
      <Collapse navbar>
        <Nav className="mr-auto" navbar style={{ display: 'contents' }}>
          <NavItem className="nav-link">Create</NavItem>
          <NavItem className="nav-link">Companies</NavItem>
        </Nav>
      </Collapse>
    </Navbar>
  )
}

export default NavigationLoading
